import { Injectable } from '@angular/core';
import { Route } from '@angular/router';

import { ClientConfigProductName, RouteProcessor } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class SportsRouteProductProcessor implements RouteProcessor {
    process(
        route: Route & {
            data: {
                product: string | undefined;
            };
        },
    ): Route | null {
        const routeProduct = route.data?.product || ClientConfigProductName.SPORTS;

        route.data = {
            ...route.data,
            product: routeProduct,
        };

        return route;
    }
}
